jQuery(document).ready(function($) {

	$.fn.andSelf = function() {
	  return this.addBack.apply(this, arguments);
	}

	$('.owl-carousel').owlCarousel({
	    items:1,
	    lazyLoad:true,
	    loop:true,
	    dots: false,
	    nav: true,
	    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
	});
	$('.grid-imovel-list.owl-carousel2').owlCarousel({
	    responsive:{
        	0:{
            	items:1,
        	},
        	780: {
        		items: 2
        	},
        	1090: {
        		items: 3
        	}
        },
	    lazyLoad:true,
	    loop:true,
	    dots: false,
	    nav: true,
	    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
	});


	$('.imovel-imagem.owl-carousel, .visualizar-galeria .owl-carousel').on('changed.owl.carousel', function(event) {

		if ($('.visualizar-galeria-imagens')[0]) {
			var current = event.item.index;
    		var key = $(event.target).find(".owl-item").eq(current).find("img").attr('data-key');
			$('.visualizar-galeria-imagens .ativo').html(key)
		}

		$(this).find('img.owl-lazy').each(function(index, el) {
			if (!$(el).attr('src') || $(el).attr('src') == null || $(el).attr('src') == '')
				$(el).attr('src', $(el).attr('data-src')).removeClass('owl-lazy');
		});
	})


	// if ($(window).width() < 1200 && $(window).width() > 780) {
	// 	$('.grid-imovel-list.no-carousel').width('100%')
	// 	$('.grid-imovel-list.no-carousel').owlCarousel({
	//     items: ($(window).width() < 780) ? 1 : 2,
	//     responsive:{
 //        	0:{
 //            	items:1,
 //        	},
 //        	780: {
 //        		items: 2
 //        	},
 //        	1090: {
 //        		items: 3
 //        	}
 //        },
	//     lazyLoad:true,
	//     loop:true,
	//     dots: false,
	//     nav: true,
	//     navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
	// })
	// }
});